import { render, staticRenderFns } from "./GestioneAttivitaAttivitaListPage.vue?vue&type=template&id=2809a23c"
import script from "./GestioneAttivitaAttivitaListPage.vue?vue&type=script&lang=js"
export * from "./GestioneAttivitaAttivitaListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports